import { render, staticRenderFns } from "./AppleMessagePWA.vue?vue&type=template&id=e9207638&scoped=true&"
import script from "./AppleMessagePWA.vue?vue&type=script&lang=ts&"
export * from "./AppleMessagePWA.vue?vue&type=script&lang=ts&"
import style0 from "./AppleMessagePWA.vue?vue&type=style&index=0&id=e9207638&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9207638",
  null
  
)

export default component.exports